export default __webpack_public_path__ + "static/media/Poppins-ExtraBold.ccb9c205.woff";